import Floorplan from './Floorplan.vue';
import LeafletMap from './LeafletMap.vue';
import SimpleMap from './SimpleMap.ts.vue';

export default [
  Floorplan,
  LeafletMap,
  SimpleMap,
];
